import Vue from 'vue';
import Vuex from 'vuex';
import mutations from "@/vuex/mutations";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        actApp:101,
        MemberInfoData:{
            name:'',
            mobile:'',
            birth:'',
            gender:'',
        },
        joinUrl:'',
        grade_code:-1,
        currentPage:'intro',
        isEncrypted:'N',
        pass_code:'',
        user_seq:0,
        test_env:false,
        login_info:{
            id:'',
            pass:'',
            seq:'',
        },
        joinUrlSet : {
            join: { // 화물맨
                path:'hmm',
                gradeCode:8
            },
            joinm: { // 만차로
                path:'mancharo',
                gradeCode:11
            },
            joina: { // 아틀란
                path:'atl',
                gradeCode:12
            },
            testjoin: { // 테스트 서버1
                path:'hmm',
                gradeCode:8
            },
            testjoina: { // 테스트 서버
                path:'hmm',
                gradeCode:8
            },
        },
        isSocialLogin: false,
        socialLogin :{
            accessToken:'',
            id: -1, // -1 : 초기화 안됨
            corpName: ''
        },
        pages:''
    },
    mutations,
    actions: {
        setMemberInfoData: ({commit},payload) =>{
            commit('setMemberInfo', payload);
        }
    },
    getters: {
        getMemberInfo: state => {
            return state.MemberInfoData;
        },
        getJoinUrl: state => {
            return state.joinUrl;
        },
        getGradeCode: state => {
            return state.grade_code;
        },
        getCurrentPage: state => {
            return state.currentPage;
        },
        getIsEncrypted: state => {
            return state.isEncrypted;
        },
        getPasscode: state => {
            return state.pass_code;
        },
        getUserSeq: state => {
            return state.user_seq;
        },
        getTestEnv: state => {
            return state.test_env;
        },
        getLoginInfo: state => {
            return state.login_info;
        },
        getJoinUrlSet: (state) => (subDomain) => {
            const joinUrlSetElement = state.joinUrlSet[subDomain];
            if (joinUrlSetElement === undefined) {
                // return state.joinUrlSet['joinm']; // test
                return state.joinUrlSet['join'];
            }
            return joinUrlSetElement;
        },
        getAccessToken: state => {
            return state.socialLogin.accessToken;
        },
        getIsSocialLogin: state => {
            return state.isSocialLogin;
        },
        getSocialCorpName: state => {
            return state.socialLogin.corpName;
        },
        getSocialId: state => {
            return state.socialLogin.id;
        },
        getPages: state => {
            return state.pages;
        }
    }
});

export default store;